import { render, staticRenderFns } from "./resume.vue?vue&type=template&id=4dc23031&scoped=true&"
import script from "./resume.vue?vue&type=script&lang=js&"
export * from "./resume.vue?vue&type=script&lang=js&"
import style0 from "./resume.vue?vue&type=style&index=0&id=4dc23031&prod&lang=less&"
import style1 from "./resume.vue?vue&type=style&index=1&id=4dc23031&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc23031",
  null
  
)

export default component.exports